import React, { createContext, useEffect, useState } from "react";
import "./App.css";
import Header from "./Includes/Header";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./Components/Home/Home";
import ClientsView from "./Components/ClientsView";
import SolarCalculator from "./Components/ShoppingTools/SolarCalculator/SolarCalculator";
import ContactUs from "./Components/ContactUs/ContactUs";
import SolarSolutions from "./Components/Solar/SolarSolutions";
import Aos from "aos";
import "aos/dist/aos.css";
import CameraSolutions from "./Components/CCTV/CameraSolutions";
import Products from "./Components/ProductPage/Products";
import ProductInfo from "./Components/ProductPage/ProductDetails/ProductInfo";
import ProductDataSets from "../src/Janica.products.json";

export const ContextStore = createContext();
const App = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
  });
  const [enquiryFormData, setEnquiryFormData] = useState({
    name: "",
    email: "",
    phone: "",
    pincode: "",
    enquiryType: "",
    message: "",
  });

  useEffect(() => {
    Aos.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="bg-bgBlack text-white">
      <ContextStore.Provider
        value={{ formData, setFormData, enquiryFormData, setEnquiryFormData }}
      >
        <BrowserRouter>
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/clients" element={<ClientsView />} />
            <Route path="/products" element={<Products />} />
            <Route
              path="/products/:category/:subcat/:id"
              element={<ProductInfo ProductDataSets={ProductDataSets} />}
            />
            <Route path="/solar-calculator" element={<SolarCalculator />} />
            <Route path="/solar-solutions" element={<SolarSolutions />} />
            <Route path="/camera-solutions" element={<CameraSolutions />} />
            <Route path="/contact-us" element={<ContactUs />} />
          </Routes>
        </BrowserRouter>
      </ContextStore.Provider>
    </div>
  );
};

export default App;
